export default __webpack_public_path__ + "static/media/rockintuna-header-bg-transparent.117783b3.png";